export const HTMLParse = (html) => {
  var parser = new DOMParser()
  const docHtml = parser.parseFromString(html, 'text/html')
  return docHtml
}

export const getData = (name) => {
  const data = sessionStorage.getItem(name)
  try {
    if (!data) {
    return []
  } else {
    return JSON.parse(data)
  }
  } catch (error) {
    return []
  }
}

export function decreaseFloatPrecission (strFloat, precission = 4) {
  const result = parseFloat(strFloat).toFixed(precission)
  return parseFloat(result)
}

export function renderMainDeviceInventoryTable(dataset, renderTable /* Function */, viewFunc /* Function */, deleteFunc /* Function */, viewPermission /* Function */, deletePermission /* Function */) {
   return Object.entries(dataset).map((data) => {
     return {
       title: data[0],
       data: renderTable(data[1], viewFunc, deleteFunc, viewPermission, deletePermission)
     }
   })
}

export const setData = (name, payload) => {
    sessionStorage.setItem(name, JSON.stringify(payload))
}

export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (!userStr) return null;
  else return JSON.parse(userStr);
}

// return the token from the session storage
export const getAccessToken = () => {
  const token = localStorage.getItem('accesstoken');
  return token
}

export const getRefreshToken = () => {
  const token = localStorage.getItem('refreshtoken');
  return token
}

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.clear()
  localStorage.clear()
}

// set the token and user from the session storage
export const setUserSession = (accessToken, refreshToken, payload) => {
  localStorage.setItem('accesstoken', accessToken);
  localStorage.setItem('refreshtoken', refreshToken);
  sessionStorage.setItem('user', JSON.stringify(payload));
}

export const refreshUserSession = (accessToken, refreshToken) => {
  localStorage.setItem('accesstoken', accessToken);
  localStorage.setItem('refreshtoken', refreshToken);
}

export const setAccessToken = (token) => {
  localStorage.setItem('accesstoken', token);
}

export const PriceFormat = (value, currency) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    maximumSignificantDigits: 21,
    currency: currency
  }).format(value)
}

export const addDashboard = (payload) => {
 return setData('dashboard', payload)
}

export const getDashboard = () => {
 try {
   const data = getData('dashboard')
   if (!data.length) {
     return {
      revenueStats: [],
      customerQty: 0,
      revenueYoy:  0,
      revenueMny: 0,
      mitra: 0,
      topSelling: {
        data: [],
        currency: 'idr',
        total: 0
      },
      realizeSell: {
        data: [],
        currency: 'idr',
        total: 0
      }
    }
   }

   return data
 } catch (error) {
   return {
      customerQty: 0,
      revenueYoy:  0,
      revenueMny: 0,
      request: 0,
      topSelling: {
        data: [],
        currency: 'idr',
        total: 0
      },
      realizeSell: {
        data: [],
        currency: 'idr',
        total: 0
      }
    }
 }
}

export const Indicator = (status) => {
    if (!status) {
      return (
        <div className="danger">Denied</div>
      )
    } else {
      return (
        <div className="success">Accept</div>
      )
    }
  }

export const getCustomerData = () => {
  const data = sessionStorage.getItem('customerData')
  return JSON.parse(data) || {
      id: '',
      name: '',
      ownerName: '',
      owner: '',
      firstname: '',
      lastname: '',
      fullname: '',
      namingSeries: '',
      ktp: '',
      mobileNo: 0,
      customergroup: '',
      creation: '',
      modified: '',
      modifiedBy: '',
      teritory: '',
      internalCustomer: '',
      isFrozen: false,
      enabled: ''
  }
}

export const decodeToken = (accessToken) => {
  try {
    const base64Url = accessToken.split('.')[1];
    if (base64Url === undefined) return null;
    const decodedValue = JSON.parse(window.atob(base64Url));

    return decodedValue;
  } catch (error) {
    // console.log(error.message)
    return {
      id: '',
      name: '',
      email: ''
    }
  }
}
